"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCalculateDefaultWelcomePackage = void 0;
var public_api_1 = require("@l2p/public-api");
var react_1 = require("react");
var swr_hooks_1 = require("@l2p/swr-hooks");
var profile_api_1 = require("@l2p/profile-api");
var useCalculateDefaultWelcomePackage = function () {
    var currency = (0, swr_hooks_1.useCurrentCurrency)();
    var firstDepBonus = (0, swr_hooks_1.usePromotionsByTag)(swr_hooks_1.BonusTag.WELCOME_DEPOSIT_FIRST).promotions;
    var secondDepBonus = (0, swr_hooks_1.usePromotionsByTag)(swr_hooks_1.BonusTag.WELCOME_DEPOSIT_SECOND).promotions;
    var thirdDepBonus = (0, swr_hooks_1.usePromotionsByTag)(swr_hooks_1.BonusTag.WELCOME_DEPOSIT_THIRD).promotions;
    var fourthDepBonus = (0, swr_hooks_1.usePromotionsByTag)(swr_hooks_1.BonusTag.WELCOME_DEPOSIT_FOURTH).promotions;
    var welcomeBonuses = (0, react_1.useMemo)(function () {
        if (!firstDepBonus || !secondDepBonus || !thirdDepBonus || !fourthDepBonus)
            return [];
        return __spreadArray(__spreadArray(__spreadArray(__spreadArray([], firstDepBonus, true), secondDepBonus, true), thirdDepBonus, true), fourthDepBonus, true);
    }, [firstDepBonus, secondDepBonus, thirdDepBonus, fourthDepBonus]);
    return (0, react_1.useMemo)(function () {
        var freeSpins = 0;
        var amount = 0;
        var percent = 0;
        var currentBonus = {
            percent: '300%',
            fs: 150,
            amount: 300,
            addedToBalanceAmount: 0,
            minDep: 0,
            maxBet: 0,
            wager: 0,
        };
        welcomeBonuses === null || welcomeBonuses === void 0 ? void 0 : welcomeBonuses.forEach(function (bonus, idx) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
            var freeRoundsCountData = (_a = bonus === null || bonus === void 0 ? void 0 : bonus.rewards) === null || _a === void 0 ? void 0 : _a.find(function (r) { return !!(r === null || r === void 0 ? void 0 : r.freeRoundsCount); });
            var percentsCountData = (_b = bonus === null || bonus === void 0 ? void 0 : bonus.rewards) === null || _b === void 0 ? void 0 : _b.find(function (r) { return !!(r === null || r === void 0 ? void 0 : r.relativePercent); });
            var freeRoundsCount = freeRoundsCountData === null || freeRoundsCountData === void 0 ? void 0 : freeRoundsCountData.freeRoundsCount;
            var percentsCount = percentsCountData === null || percentsCountData === void 0 ? void 0 : percentsCountData.relativePercent;
            freeSpins += freeRoundsCount || 0;
            percent += percentsCount || 0;
            var maxBonusData = (_c = bonus === null || bonus === void 0 ? void 0 : bonus.constraints) === null || _c === void 0 ? void 0 : _c.find(function (r) { return (r === null || r === void 0 ? void 0 : r.type) === public_api_1.BonusConstraintType.MaxBonus; });
            var maxBonus = (_d = maxBonusData === null || maxBonusData === void 0 ? void 0 : maxBonusData.maxBonus) === null || _d === void 0 ? void 0 : _d.find(function (b) { return b.currency === currency; });
            var maxBonusAmount = maxBonus === null || maxBonus === void 0 ? void 0 : maxBonus.amount;
            if (idx === 0) {
                var percentFromFirstBonus = ((_f = (_e = bonus === null || bonus === void 0 ? void 0 : bonus.rewards) === null || _e === void 0 ? void 0 : _e.find(function (r) { return r.type === public_api_1.BonusRewardType.Relative; })) === null || _f === void 0 ? void 0 : _f.relativePercent) || 0;
                var fsFromFirstBonus = ((_h = (_g = bonus === null || bonus === void 0 ? void 0 : bonus.rewards) === null || _g === void 0 ? void 0 : _g.find(function (r) {
                    return r.type === public_api_1.BonusRewardType.FreeRounds ||
                        r.type === public_api_1.BonusRewardType.RepeatableFreeRounds;
                })) === null || _h === void 0 ? void 0 : _h.freeRoundsCount) || 0;
                var minDepFromFirstBonus = (_k = (_j = bonus === null || bonus === void 0 ? void 0 : bonus.conditions) === null || _j === void 0 ? void 0 : _j.find(function (r) { return r.type === profile_api_1.BonusConditionType.MinDepositAmount; })) === null || _k === void 0 ? void 0 : _k.minDeposit;
                var maxBetFromFirstBonus = (_m = (_l = bonus === null || bonus === void 0 ? void 0 : bonus.constraints) === null || _l === void 0 ? void 0 : _l.find(function (r) { return r.type === public_api_1.BonusConstraintType.MaxBet; })) === null || _m === void 0 ? void 0 : _m.maxBet;
                currentBonus.percent =
                    percentFromFirstBonus > 0 ? "".concat(percentFromFirstBonus, "%") : 0;
                currentBonus.fs = fsFromFirstBonus;
                currentBonus.minDep = (_o = minDepFromFirstBonus === null || minDepFromFirstBonus === void 0 ? void 0 : minDepFromFirstBonus.find(function (b) { return b.currency === currency; })) === null || _o === void 0 ? void 0 : _o.amount;
                currentBonus.maxBet = (_p = maxBetFromFirstBonus === null || maxBetFromFirstBonus === void 0 ? void 0 : maxBetFromFirstBonus.find(function (b) { return b.currency === currency; })) === null || _p === void 0 ? void 0 : _p.amount;
                currentBonus.wager = (bonus === null || bonus === void 0 ? void 0 : bonus.wageringMultiplier) || 0;
            }
            amount += maxBonusAmount || 0;
        });
        return {
            percent: Number(percent) > 0 ? "".concat(percent, "%") : 0,
            freeSpins: freeSpins,
            amount: amount,
            currentBonus: currentBonus,
        };
    }, [currency, welcomeBonuses]);
};
exports.useCalculateDefaultWelcomePackage = useCalculateDefaultWelcomePackage;
